<template>
  <section
    v-if="imprint"
    id="single-page"
  >
    <BaseBasicPage :page-content="imprint" />
  </section>
</template>

<script>
import BaseBasicPage from '../components/base/BaseBasicPage'
import gql from 'graphql-tag'

export default {
    apollo: {
        imprint: {
            query: gql `
            query Imprint {
                imprint {
                  content_en
                  content_no
                }
            }
        `
        }
    },
    metaInfo() {
        return { 
            title: this.$t("nav.imprint"),
        }
    },
    components: {
        BaseBasicPage
    }
}
</script>